import { Raffle } from '@/app/entities/Raffle'
import { withCdn } from '@/app/utils/withCdn'
import { Link } from 'react-router-dom'
import { ActiveRaffleSkeleton } from './ActiveRaffleSkeleton'

interface ActiveRafflesProps {
  raffles: Raffle[] | undefined
  isLoading: boolean
}

const ActiveRaffles: React.FC<ActiveRafflesProps> = ({
  raffles,
  isLoading,
}) => {
  if (isLoading) {
    return <ActiveRaffleSkeleton />
  }

  if (!raffles || raffles.length === 0) {
    return <p>Nenhum sorteio ativo disponível.</p>
  }

  return (
    <div className="flex gap-2 overflow-x-auto sm:gap-4">
      {raffles.map((raffle) => (
        <Link to={`/sorteios/${raffle?._id}`} key={raffle?._id}>
          <div
            className="relative h-[280px] w-[180px] flex-shrink-0 rounded-3xl bg-contain bg-center bg-no-repeat sm:h-[320px] sm:w-[220px] md:h-[380px] md:w-[260px] lg:h-[451px] lg:w-[310px]"
            style={{
              backgroundImage: `url(${withCdn(raffle?.banner)})`,
              aspectRatio: '1179 / 1600',
            }}
          >
            <div className="absolute right-2 top-2 rounded-full bg-white px-3 py-2 text-sm font-semibold text-primary shadow shadow-black/30 sm:right-3 sm:top-3 sm:px-4 sm:py-2 md:right-4 md:top-4 md:px-5 md:py-[10px] md:text-base lg:right-5 lg:top-5">
              {raffle?.coupons || 0}
            </div>
          </div>
        </Link>
      ))}
    </div>
  )
}

export default ActiveRaffles
